const API = '/api/'

const ACCOUNT = `${API}accounts`;
const PERMISSION = `${API}permissions`
const USER = `${API}users`;
const COMPANY = `${API}companies`;
const EMPLOYEE = `${API}employees`;
const VENDOR = `${API}vendors`;
const SERVICE = `${API}services`;
const SERVICE_ESTIMATE_RATE = `${API}service-estimate-rates`;
const COMPANY_SERVICE_FIXED_CHARGE = `${API}company-service-fixed-charges`
const INVOICE = `${API}invoices`;
const FINANCIAL_YEAR = `${API}financialyear`;
const COMPANY_EMPLOYEE = `${API}company-employees`;

const SERVICE_CATEGORY = `${API}service-categories`
const EMPLOYEE_TYPE = `${API}employeetype`
const DEVICE_TYPE = `${API}device-types`
const LICENSE = `${API}license`
const REPORT = `${API}reports`

const SMTP_SETTINGS = `${API}smtpsettings`;

const USER_API = {
  USERS: USER,
  LIST: `${USER}/list`,
  CHANGE_PASSWORD: `${USER}/change-password`,
  FORGOT_PASSWORD: `${USER}/forgot-password`,
  RESET_PASSWORD: `${USER}/reset-password`,
};
const COMPANY_API = {
  COMPANY,
  LIST: `${COMPANY}/list`
};
const EMPLOYEE_API = {
  EMPLOYEE,
  LIST: `${EMPLOYEE}/list`
};
const VENDOR_API = {
  VENDOR,
  LIST: `${VENDOR}/list`
};
const SERVICE_API = {
  SERVICE,
  LIST: `${SERVICE}/list`,
};
const SERVICE_ESTIMATE_RATE_API = {
  SERVICE_ESTIMATE_RATE,
  LIST: `${SERVICE_ESTIMATE_RATE}/list`,
}
const COMPANY_SERVICE_FIXED_CHARGE_API = {
  COMPANY_SERVICE_FIXED_CHARGE,
  LIST: `${COMPANY_SERVICE_FIXED_CHARGE}/list`,
}
const COMPANY_EMPLOYEE_API = {
  COMPANY_EMPLOYEE,
  ASSIGN: `${COMPANY_EMPLOYEE}/assign`,
  EMPLOYEES: `${COMPANY_EMPLOYEE}/employees`,
  SERVICE_END: `${COMPANY_EMPLOYEE}/service-end`,
}
const INVOICE_API = {
  INVOICE,
  LIST: `${INVOICE}/list`,
};
const MASTER_API = {
  FINANCIAL_YEAR_LIST: `${FINANCIAL_YEAR}/list`,
};

const SERVICE_CATEGORY_API = {
  SERVICE_CATEGORY,
  LIST: `${SERVICE_CATEGORY}/list`
};
const EMPLOYEE_TYPE_API = {
  EMPLOYEE_TYPE,
  LIST: `${EMPLOYEE_TYPE}/list`
};
const DEVICE_TYPE_API = {
  DEVICE_TYPE,
  LIST: `${DEVICE_TYPE}/list`
};
const LICENSE_API = {
  LICENSE,
  LIST: `${LICENSE}/list`
};
const SMTP_SETTINGS_API = {
  SMTP_SETTINGS,
}

const REPORT_API = {
  LICENSE_TO_COMPANY: `${REPORT}/LicenseToCompany`,
  LICENSE_TO_COMPANY_EXCEL: `${REPORT}/LicenseToCompany/Excel`,
  BUDGET: `${REPORT}/Budget`,
  BUDGET_EXCEL: `${REPORT}/Budget/Excel`,
}

const PERMISSION_API = {
  LIST: `${PERMISSION}/list`
};

const ACCOUNT_API = {
  LOGIN: `${ACCOUNT}/login`,
  VERIFY_OTP: `${ACCOUNT}/verify-otp`,
  LOGOUT: `${ACCOUNT}/logout`
}

export {
  USER_API, COMPANY_API, EMPLOYEE_API, VENDOR_API, SERVICE_API, INVOICE_API,
  SERVICE_CATEGORY_API, EMPLOYEE_TYPE_API, DEVICE_TYPE_API, LICENSE_API,
  MASTER_API, COMPANY_SERVICE_FIXED_CHARGE_API, SERVICE_ESTIMATE_RATE_API,
  SMTP_SETTINGS_API, COMPANY_EMPLOYEE_API, REPORT_API, PERMISSION_API,
  ACCOUNT_API,
}